export default __webpack_public_path__ + "static/media/icon__close.748696a4.svg";